<template>
    <div class="profile__left">
        <h3>{{ $t('profile.my_profile_title') }}</h3>
<!--        <div-->
<!--            class="profile__left-photo"-->
<!--            id="profile_photo"-->
<!--        ></div>-->

        <img v-show="authStore.userInfo.imagePath" class="profile__left-photo" id="profile_photo" :src="authStore.userInfo.imagePath"/>
        <img v-show="!authStore.userInfo.imagePath" class="profile__left-photo" id="profile_photo_blank" src="@/assets/images/blank_person.jpg" />

        <button v-show="!uploadImageButton" class="profile__left-photo-btn" @click="uploadImageButton = true">{{$t('profile.change_image_title')}}</button>
        <input v-show="uploadImageButton && !imageDuringUpload" id="file" ref="image" @input="uploadImage" type="file" name="profile_image" accept="image/*">
        <div class="upload-file-loader">
            <loader v-show="imageDuringUpload" />
        </div>
        <button class="profile__left-photo-btn" @click="removeImage">{{$t('profile.remove_image')}}</button>
        <div class="specs">
            <p class="specs__title">{{$t('profile.specjalizations')}}</p>
            <div class="specs__list" >
                <div class="specs__item specs__item--edit" v-for="specjalization in authStore.userInfo.userSpecializations" :key="specjalization.id">
                    {{specjalization.name}} <button @click="removeTag(specjalization.id)">X</button>
                </div>
            </div>
            <div class="specs__form select">
                <!--                                <Autocomplete-->
                <!--                                    @input="getItems"-->
                <!--                                    :results="items"-->
                <!--                                    @onSelect="chooseTagItem"-->
                <!--                                    v-model="searchText"-->
                <!--                                />-->
                <select v-model="chosenSpecialization">
                    <option value="0">{{$t('profile.choose_label')}}</option>
                    <option v-for="specialization in allSpecialization" :value="specialization.id">{{specialization.name}}</option>
                </select>
                <!--                                <input type="text" v-model="tagDescription" :placeholder="$t('profile.enter_tag_placeholder')" />-->
                <!--                                <button>-->
                <!--                                    <svg xmlns="http://www.w3.org/2000/svg" width="16.124" height="12.293" viewBox="0 0 16.124 12.293">-->
                <!--                                        <path id="Path_539" data-name="Path 539" d="M8.534,15.288,4.712,11.466l-1.3,1.293,5.124,5.124,11-11L18.242,5.59Z" transform="translate(-3.41 -5.59)" fill="#353535"/>-->
                <!--                                    </svg>-->

                <!--                                </button>-->
                <!--                                <button @click="tagDescription = ''">-->
                <!--                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">-->
                <!--                                        <path id="Path_541" data-name="Path 541" d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z" transform="translate(-5 -5)" fill="#353535"/>-->
                <!--                                    </svg>-->

                <!--                                </button>-->
            </div>
            <button @click="addSpecialization" class="specs__add">{{$t('profile.add_new_tag')}}</button>

        </div>
        <!--                    <div class="rating">-->
        <!--                        <p class="rating__title">-->
        <!--                            Średnia ocena: <strong>6,7/10</strong>-->
        <!--                        </p>-->
        <!--                        <div class="rating__item">-->
        <!--                            <p class="rating__item-title">Kontakt</p>-->
        <!--                            <div class="rating__item-bottom">-->
        <!--                                <div class="rating__item-line">-->
        <!--                                    <div-->
        <!--                                        class="rating__item-line-inner"-->
        <!--                                        style="width: 80%"-->
        <!--                                    ></div>-->
        <!--                                </div>-->
        <!--                                <div class="rating__item-count">8/10</div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                        <div class="rating__item">-->
        <!--                            <p class="rating__item-title">Wizualizacje</p>-->
        <!--                            <div class="rating__item-bottom">-->
        <!--                                <div class="rating__item-line">-->
        <!--                                    <div-->
        <!--                                        class="rating__item-line-inner"-->
        <!--                                        style="width: 50%"-->
        <!--                                    ></div>-->
        <!--                                </div>-->
        <!--                                <div class="rating__item-count">5/10</div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                        <div class="rating__item">-->
        <!--                            <p class="rating__item-title">Cena</p>-->
        <!--                            <div class="rating__item-bottom">-->
        <!--                                <div class="rating__item-line">-->
        <!--                                    <div-->
        <!--                                        class="rating__item-line-inner"-->
        <!--                                        style="width: 60%"-->
        <!--                                    ></div>-->
        <!--                                </div>-->
        <!--                                <div class="rating__item-count">6/10</div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <div class="description control--text">
            <p class="description__title">{{$t('profile.description_title')}}</p>
            <textarea name="" id="" v-model="description"></textarea>
            <div v-show="errors.description" class="control__error">
                <div class="control__error-inner">
                    {{errors.description}}
                </div>
            </div>
        </div>
        <div class="line"></div>
        <div class="socials">
            <div class="control control--input">
                <label for="fb" class="control__label">{{$t('profile.facebook_url_title')}}</label>
                <input
                    type="text"
                    id="fb"
                    :placeholder="$t('profile.enter_link_placeholder')"
                    v-model="facebookUrl"
                />
                <div v-show="errors.facebookUrl" class="control__error">
                    <div class="control__error-inner">
                        {{errors.facebookUrl}}
                    </div>
                </div>
            </div>
            <div class="control control--input">
                <label for="instagram" class="control__label"
                >{{$t('profile.instagram_url_title')}}</label
                >
                <input
                    type="text"
                    id="instagram"
                    :placeholder="$t('profile.enter_link_placeholder')"
                    v-model="instagramUrl"
                />
                <div v-show="errors.instagramUrl" class="control__error">
                    <div class="control__error-inner">
                        {{errors.instagramUrl}}
                    </div>
                </div>
            </div>
        </div>
        <div class="buttons">
            <button class="button-outline" @click.prevent="saveFirstColumn">
                <template v-if="!authStore.isLoading">
                    {{$t('profile.button_label')}}
                </template>
                <template v-else>
                    {{$t('profile.updating')}}...
                </template>

            </button>
        </div>
    </div>

</template>

<script>
import axios from "axios";
import authHelper from "@/helpsers/auth.helper";
import {ref} from "vue";
import ApiHelper from "@/helpsers/api.helper";
import {useAuthStore} from "@/stores/auth.store";
import {useI18n} from "vue-i18n";
import {useField, useForm} from "vee-validate";
import * as yup from "yup";
import {inject} from "vue";
import UserService from "@/services/user.service";
import Loader from "@/components/loader";
import AlertHelper from "@/helpsers/alert.helper";

export default {
    name: "ProfileLeft",
    components: {Loader},
    setup() {
        const authStore = useAuthStore();
        const {t} = useI18n();
        let alert = inject('alert');
        const uploadImageButton = ref(false);
        const imageDuringUpload = ref(false);
        const userService = new UserService();

        const { handleSubmit, errors } = useForm({
            validationSchema: yup.object().shape({
                facebookUrl: yup.string()
                    .matches(/((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,{message: t('profile.validation.wrong_url'), excludeEmptyString: true})
                    .trim(),
                instagramUrl: yup.string()
                    .matches(/((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,{message: t('profile.validation.wrong_url'), excludeEmptyString: true})
                    .trim(),
                description: yup.string().trim(),
            }),
            initialValues: {
                facebookUrl: authStore.userInfo.facebookUrl,
                instagramUrl: authStore.userInfo.instagramUrl,
                description: authStore.userInfo.description,
            }
        });

        const { value: facebookUrl } = useField('facebookUrl');
        const { value: instagramUrl} = useField('instagramUrl');
        const { value: description } = useField('description');

        const saveFirstColumn = handleSubmit(async () => {

            authStore.isLoading = true;

            const data = {
                facebookUrl: facebookUrl.value,
                instagramUrl: instagramUrl.value,
                description: description.value,
                userSpecializationsIds: Object.values(authStore.userInfo.userSpecializations).map((key) => key.id)
            };

            axios.put(ApiHelper.getUpdateUserUrl(), data, {
                headers: authHelper.authHeader()
            }).then(response => {
                authStore.isLoading = false;
                AlertHelper.show(alert, t('profile.update_success'));
                authStore.userInfo.facebookUrl = facebookUrl.value;
                authStore.userInfo.instagramUrl = instagramUrl.value;
                authStore.userInfo.description = description.value;
            }).catch(errorResponse => {
                authStore.isLoading = false;
                let errorMessage = ApiHelper.getResponseMessage(errorResponse.response?.data?.code);
                AlertHelper.show(alert, errorMessage, '', 'error');
            })
        })

        const allSpecialization = ref(''),
            chosenSpecialization = ref(0);

        axios.get(ApiHelper.getAllSpecializationUrl(), {
            headers: authHelper.authHeader()
        })
            .then(result => {
                allSpecialization.value = result.data
            });

        function addSpecialization () {
            let result = allSpecialization.value.filter(el => el.id == chosenSpecialization.value)[0];
            const existIsSpecialization = authStore.userInfo.userSpecializations.filter(el => el.id == chosenSpecialization.value);
            if(existIsSpecialization.length == 0)
                authStore.userInfo.userSpecializations.push({
                    id: chosenSpecialization.value,
                    name: result.name
                });

            chosenSpecialization.value = 0;
        }

        function removeTag(id) {
            authStore.userInfo.userSpecializations = authStore.userInfo.userSpecializations.filter(el => el.id != id);
        }


        function uploadImage() {
            imageDuringUpload.value = true;
            let photo = document.querySelector("#file").files[0];
            let formData = new FormData();

            formData.append("file", photo);
            formData.append("type", 'PROFILE');


           userService.setUserProfileImage(formData)
               .then(r => {
                   imageDuringUpload.value = false;
                   uploadImageButton.value = false;

                   AlertHelper.show(alert, t('admin.profile.img_update_success'));
               })
               .catch(e => {
                   imageDuringUpload.value = false;
                   uploadImageButton.value = false;

                   let errorMessage = ApiHelper.getResponseMessage(e.response?.data?.code);
                   AlertHelper.show(alert, errorMessage, '', 'error');
               });
        }

        // document.querySelector("#profile_photo").src = objectURL;


        function removeImage() {
            userService.removeUserProfileImage()
                .then(() => {
                    AlertHelper.show(alert, t('profile.img_delete_success'));
                })
                .catch((error) => {
                    let errorMessage = ApiHelper.getResponseMessage(error.response?.data?.code);
                    AlertHelper.show(alert, errorMessage, '', 'error');
                })
        }

        return {
            saveFirstColumn,
            addSpecialization,
            allSpecialization,
            chosenSpecialization,
            removeTag,
            authStore,
            facebookUrl,
            instagramUrl,
            description,
            errors,
            uploadImageButton,
            uploadImage,
            removeImage,
            imageDuringUpload,
        }
    }
}
</script>

<style scoped lang="scss">
.upload-file-loader {
    margin: 20px 0;
}
.profile {
    &__left {
        &-photo-btn {
            cursor: pointer;
        }
        &-photo {
            display: flex;
            align-items: center;
            object-fit: cover;
        }
    }
    .specs__add {
        cursor: pointer;
        margin-top: 10px;
    }
    .specs__form {
        select {
            width: 100%;
        }
        button {
            cursor: pointer;
        }
    }
}

.control {
    display: flex;
    flex-direction: column;
    position: relative;
    &:not(:last-of-type) {
        margin-bottom: 29px;
    }
    &__label {
        font-size: 1.6rem;
        line-height: 19px;
        margin-bottom: 8px;
        font-weight: 500;
    }
    &--input {
        input {
            height: 32px;
            background-color: #fff;
            border: 1px solid #d4d1d1;
            border-radius: 5px;
            width: 100%;
            padding: 0 10px;
            font-size: 1.6rem;
            font-family: Montserrat, sans-serif;
            outline: none;
            color: #000;
            max-width: 294px;
            &::placeholder {
                color: #d4d1d1;
                opacity: 1;
            }

            &::-ms-input-placeholder {
                color: #d4d1d1;
            }
            &.error {
                border-color: #ed685b;
            }
        }
    }
    &--text {
        textarea {
            border: 1px solid #d4d1d1;
            border-radius: 5px;
            resize: none;
            height: 175px;
            width: 100%;
            font-family: Montserrat, sans-serif;
            padding: 12px;
            font-size: 1.5rem;
            line-height: 19px;
        }
    }
    &--password {
        position: relative;
        .control__eye {
            background-color: transparent;
            border: none;
            box-shadow: none;
            position: absolute;
            right: 19px;
            bottom: 16px;
            padding: 0;
            height: 24px;
        }
    }
    &--check {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: row;
        label {
            max-width: calc(100% - 42px);
            margin-bottom: 0;
            a {
                text-decoration: underline;
                font-weight: 500;
                color: black;
            }
        }
        input {
            appearance: none;
            margin-right: 23px;
            position: relative;
            &::before {
                content: "";
                display: block;
                width: 14px;
                height: 14px;
                border-radius: 2px;
                border: 2px solid #00000099;
                transition: all ease 500ms;
            }

            &::after {
                position: absolute;
                content: "";
                display: block;
                left: 5px;
                top: 1px;
                width: 5px;
                height: 10px;
                border: solid white;
                border-width: 0 3px 3px 0;
                transform: rotate(45deg);
                opacity: 0;
                transition: opacity ease 500ms;
            }
            &:checked {
                &::before {
                    border-color: #9e5d57;
                    background-color: #9e5d57;
                }
                &::after {
                    opacity: 1;
                }
            }
        }
    }
}
.buttons {
    margin-top: 40px;
}
</style>